import { Klass, u_, csl } from "@pressmedia/webappbase";

import dataKey from "./_dataKey";
import ajaxErrorCallback from "./_ajaxErrorCallback";
import sendRequest from "./_sendRequest";
import config from "./_config";
import loadItems from "./_loadItems";
import wysiwyg from "./_wysiwyg";

/****************************
* define Klass TyrellModule *
****************************/
Klass.create("TyrellModule", Object.assign({
	// コンストラクタで設定可能なメンバーリスト
	_enableSetOptions: [
		"app",	// required {WebAppBase instance},
		"config",	// {object} 設定データ格納用オブジェクト
		"apiBaseUrl",	// {string} リクエストオーダー先ベースURL
		"getFilter",	// {object} データ取得時のフィルタ設定 (サーバー側)
		"errorCallbacks",	// {object} サーバーから（明示的に）エラーが返って来た場合のコールバック集
		"configOverride",	//{object}  設定データの上書き
		"pkGroupByDate",
		"byDateFormat",
		"itemFilter"
	],
	
	// 一覧データの日付によるグループ分けのキー（年月ごとのグループ分け）
	pkGroupByDate: "dateUpd",
	
	// 一覧データの日付によるグループ分けのフォーマット ※未指定の場合は"YYYY-MM"
	byDateFormat: "YYYY-MM",
	
	
	// ** default member functions **
	// 一覧データのフィルタリング関数 (falseを返すとそのデータをキック)
	itemFilter(i, item, res) {},
	
	
	/**
	 * [コンストラクタ]
	 * @param {Object} dataKey: コンテンツのキー
	 * @param {Object} opt: オプション値
	 * @returns this
	 */
	
	_initialize(dataKey, opt) {
		if( u_.isString(dataKey) ) {
			this.setDataKey(dataKey);
		} else
		if( u_.isObject(dataKey) ) {
			// 第１引数にオブジェクトが渡された場合は、オプションとする
			opt = dataKey;
		}
		
		u_.isObject(opt) || (opt = {});
		
		if( !( opt.app instanceof Klass("WebAppBase") ) ) {
			throw new TypeError("'app' must be an instance of WebAppBase.");
		}
		
		u_.isObject(opt.config) || (opt.config = {});
		
		if(!opt.apiBaseUrl && opt.app.config.apipath) {
			opt.apiBaseUrl = opt.app.config.apipath;
		}
		
		// オプション値の反映
		Object.keys(opt).forEach(member => {
			if( this[member] === undefined || this._enableSetOptions.indexOf(member) >= 0 ) {
				if( this[member] && u_.isObject(this[member]) && u_.isObject(opt[member]) ) {
					this[member] = Object.assign({}, this[member], opt[member]);
				} else {
					this[member] = opt[member];
				}
			} else {
				csl.warn(`TyrellModule:: \`${member}\` is not apply.`);
			}
		});
		
		// サーバーから（明示的に）エラーが返って来た場合のコールバック集
		u_.isObject(this.errorCallbacks) || (this.errorCallbacks = {});
		u_.isFunction(this.errorCallbacks.def) || (this.errorCallbacks.def = this.defaultErrorCallback);
		
		return this;
	},
	
	/**
	 * アラート表示
	 * @return $.Deferred().promise()
	 */
	async alert(msg, cb) {
		if( u_.isFunction(this.app.alert) ) {
			return this.app.alert.apply(this.app, arguments);
		} else {
			if( u_.isString(msg) && msg ) {
				alert( u_.replaceHtmlTag( msg.replace(/<br\/?>/g, "\n") ) );
			}
			return !u_.isFunction(cb) || cb();
		}
	},
	
}, dataKey, ajaxErrorCallback, sendRequest, config, loadItems, wysiwyg));
